import { Typography } from '@mui/material';

interface QuickStartErrorTextProps {
  error: string;
}
const QuickStartErrorText = ({ error }: QuickStartErrorTextProps) => (
  <Typography sx={{
    fontFamily:'Schibsted Grotesk, sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    color: 'red',
    lineHeight: '125%',
  }}>*{error}
  </Typography>

);

export default QuickStartErrorText;